export default __webpack_public_path__ + "static/media/bg-footer-top-desktop.8c0b6c1d.svg";